import { render, staticRenderFns } from "./AssessmentComponent.vue?vue&type=template&id=023c4f28&scoped=true"
import script from "./AssessmentComponent.vue?vue&type=script&lang=js"
export * from "./AssessmentComponent.vue?vue&type=script&lang=js"
import style0 from "./AssessmentComponent.vue?vue&type=style&index=0&id=023c4f28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023c4f28",
  null
  
)

export default component.exports